"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateVersion2toVersion3 = void 0;
const updateVersion2toVersion3 = (configuration) => {
    return Object.assign(Object.assign({}, configuration), { version: 3, content: configuration.content.status === "ready"
            ? Object.assign(Object.assign({}, configuration.content), { downloadScriptUrl: null, downloadVideoUrl: null }) : configuration.content });
};
exports.updateVersion2toVersion3 = updateVersion2toVersion3;
//# sourceMappingURL=v3.js.map